module.exports = __webpack_public_path__ + "img/疫苗.1a062b37.png";